var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookappointmenticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2388 5.85889H2.76117C1.82302 5.85889 1.0625 6.61941 1.0625 7.55756V28.791C1.0625 29.7291 1.82302 30.4896 2.76117 30.4896H31.2388C32.177 30.4896 32.9375 29.7291 32.9375 28.791V7.55756C32.9375 6.61941 32.177 5.85889 31.2388 5.85889Z",
    fill: "#D4825B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2379 5.85889H3.9682C3.03005 5.85889 2.26953 6.61941 2.26953 7.55756V28.791C2.26953 29.7291 3.03005 30.4896 3.9682 30.4896H31.2379C32.1761 30.4896 32.9366 29.7291 32.9366 28.791V7.55756C32.9366 6.61941 32.1761 5.85889 31.2379 5.85889Z",
    fill: "#F2B091"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0625 10.9297H32.9375V22.1769C32.9375 25.6732 30.0767 28.5333 26.5811 28.5333H3.38074C2.10574 28.5333 1.0625 27.4901 1.0625 26.2151V10.9297Z",
    fill: "#E0DCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26953 10.9297H32.9366V22.1769C32.9366 25.6732 30.0765 28.5333 26.5802 28.5333H4.58777C3.31277 28.5333 2.26953 27.4901 2.26953 26.2151V10.9297Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.923 23.3073C29.6582 23.9335 32.3032 22.7833 32.9367 21.0342V22.177C32.9367 25.6733 30.0759 28.5334 26.5803 28.5334H26.3691C28.0193 27.6735 28.7737 24.9435 27.923 23.3073Z",
    fill: "#E0DCDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80836 5.85889V7.2833C5.80836 7.79131 5.39266 8.20701 4.88465 8.20701C4.37664 8.20701 3.96094 7.79131 3.96094 7.2833V5.85889H5.80836Z",
    fill: "#D4825B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45691 3.51025C5.96492 3.51025 6.38063 3.92596 6.38063 4.43396V7.28346C6.38063 7.79147 5.96492 8.20717 5.45691 8.20717C4.94891 8.20717 4.5332 7.79147 4.5332 7.28346V4.43396C4.5332 3.92596 4.94891 3.51025 5.45691 3.51025Z",
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.367 5.85889V7.2833C13.367 7.79131 12.9513 8.20701 12.4432 8.20701C11.9352 8.20701 11.5195 7.79131 11.5195 7.2833V5.85889H13.367Z",
    fill: "#D4825B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0155 3.51025C13.5235 3.51025 13.9392 3.92596 13.9392 4.43396V7.28346C13.9392 7.79147 13.5235 8.20717 13.0155 8.20717C12.5075 8.20717 12.0918 7.79147 12.0918 7.28346V4.43396C12.0918 3.92596 12.5075 3.51025 13.0155 3.51025Z",
    fill: "#ECEFF1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9275 5.85889V7.2833C20.9275 7.79131 20.5118 8.20701 20.0038 8.20701C19.4958 8.20701 19.0801 7.79131 19.0801 7.2833V5.85889H20.9275Z",
    fill: "#D4825B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5741 3.51025C21.0821 3.51025 21.4978 3.92596 21.4978 4.43396V7.28346C21.4978 7.79147 21.0821 8.20717 20.5741 8.20717C20.0661 8.20717 19.6504 7.79147 19.6504 7.28346V4.43396C19.6504 3.92596 20.0661 3.51025 20.5741 3.51025Z",
    fill: "#ECEFF1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4861 5.85889V7.2833C28.4861 7.79131 28.0704 8.20701 27.5624 8.20701C27.0544 8.20701 26.6387 7.79131 26.6387 7.2833V5.85889H28.4861Z",
    fill: "#D4825B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1346 3.51025C28.6427 3.51025 29.0584 3.92596 29.0584 4.43396V7.28346C29.0584 7.79147 28.6427 8.20717 28.1346 8.20717C27.6266 8.20717 27.2109 7.79147 27.2109 7.28346V4.43396C27.2109 3.92596 27.6266 3.51025 28.1346 3.51025Z",
    fill: "#ECEFF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5065 18.257V22.0867H18.4324V27.1608H14.6027V22.0867H9.5293V18.257H14.6027V13.1836H18.4324V18.257H23.5065Z",
    fill: "#E0DCDC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9889 17.8166V21.6463H18.9155V26.7204H15.0852V21.6463H10.0117V17.8166H15.0852V12.7432H18.9155V17.8166H23.9889Z",
    fill: "#F56C61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookappointmenticon);
export default __webpack_public_path__ + "static/media/bookappointmenticon.bf3cfba7dac4a58835dfd0e17de96f90.svg";
export { ForwardRef as ReactComponent };